"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Separator } from "@/components/ui/separator";
export default function Story() {
  const image = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const text = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="3397" id="built-by-hand" className="bg-background text-foreground py-24 md:py-32 lg:py-40 font-default">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {}
          <div ref={image.ref} className={`lg:col-span-5 transition-all duration-1000 ease-out ${image.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="relative">
              <AspectRatio ratio={4 / 5} className="overflow-hidden">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/miss_yvonne_vessel.webp" alt="The Miss Yvonne fishing vessel docked at the harbor" loading="lazy" decoding="async" className="h-full w-full object-cover" />
              </AspectRatio>
              <div className="absolute bottom-4 right-4 md:bottom-6 md:right-6">
                <span className="font-mono text-[10px] md:text-xs uppercase tracking-[0.2em]" style={{
                color: "var(--primary)"
              }}>
                  The Miss Yvonne — Ocean Springs, 1965
                </span>
              </div>
            </div>
          </div>

          {}
          <div ref={text.ref} className={`lg:col-span-7 lg:pl-4 transition-all duration-1000 ease-out delay-200 ${text.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {}
            <div className="flex items-center gap-3 mb-10">
              <span className="font-mono text-xs uppercase tracking-[0.3em]" style={{
              color: "var(--primary)"
            }}>
                — Our Heritage
              </span>
            </div>

            {}
            <h2 className="font-serif text-3xl md:text-4xl lg:text-[3rem] leading-[1.15] tracking-tight text-foreground font-light">
              We didn&rsquo;t just build a boat. We built a{" "}
              <em className="italic font-normal" style={{
              color: "var(--primary)"
            }}>
                legacy
              </em>{" "}
              of wild-caught quality.
            </h2>

            {}
            <Separator className="my-10 md:my-12 h-px" style={{
            backgroundColor: "var(--primary)"
          }} />

            {}
            <div className="space-y-8 max-w-2xl">
              <p className="text-[17px] md:text-[18px] leading-[1.7] text-muted-foreground">
                <span className="float-left font-serif text-[3rem] leading-[0.85] mr-3 mt-1" style={{
                color: "var(--primary)"
              }}>
                  I
                </span>
                t began in 1965 in Ocean Springs, Mississippi. The Miss Yvonne was 
                more than a vessel; she was a promise of hard work and honest 
                harvesting. For decades, she has navigated the Gulf, representing 
                a commitment to sustainable fishing practices that honor the 
                ocean and the local communities we serve.
              </p>

              <p className="text-[17px] md:text-[18px] leading-[1.7] text-muted-foreground">
                <span className="float-left font-serif text-[3rem] leading-[0.85] mr-3 mt-1" style={{
                color: "var(--primary)"
              }}>
                  W
                </span>
                e believe that the best seafood is caught with care and delivered 
                with integrity. Every catch brought aboard the Miss Yvonne is 
                handled with the same precision today as it was fifty years ago. 
                From our deck to your table, we ensure that every fillet reflects 
                the timeless quality of our heritage.
              </p>
            </div>

            {}
            <div className="mt-12 flex justify-end">
              <span className="font-serif italic text-xl md:text-2xl" style={{
              color: "var(--primary)"
            }}>
                — The Captain &amp; Crew
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}